import React from "react";
import Typography from "@material-ui/core/Typography";
import {ListItems} from "./ListItems";

export const MenuItems = props =>{
    return(
     <>
            <Typography variant='h6' className='text-center mt-3 mb-3'>
                Rekords Panal
            </Typography>

            <ListItems/>
        </>
    );
}